import { useGlobalState } from "../context/context";
import { useLocalStorage } from "./useLocalStorage"
import { useToast } from "./useToast";
import { useUser } from "./useUser";

export interface CartItem {
    type: 'furniture' | 'imported furniture';
    name: string;
    id: string;
    image: string;
    link: string;
    producer: string;
};

export const useCart = () => {
    const localStorage = useLocalStorage();
    const { dispatch } = useGlobalState();
    const toast = useToast();
    const user = useUser();

    const get = () => {
        const cartItems = localStorage.get('cart') || null;
        dispatch({ type: 'setCart', basketFurniture: cartItems })
    }

    const isInCart = (id: string) => {
        const cart = localStorage.get('cart') || [];
        return cart.some((item: CartItem) => item.id === id);
    }

    const add = (item: CartItem) => {
        const cart = localStorage.get('cart') || [];

        if (cart.length > 4 && !user.isAuth) return (
            toast.error('Jedna wycena może zawierać maksymalnie 5 produktów!')
        )

        if (cart.find((i: CartItem) => i.id === item.id)) return
        if (!user.isAuth) {
            if (item.producer === '6410ff940938130d280c01de') return toast.error('Przepraszamy, ale ten producent nie pozwala na internetową wycenę. W celu wyceny tego produktu odwiedź jeden z naszych salonów.')
        }

        cart.push(item);
        localStorage.set('cart', cart);

        dispatch({ type: 'setCart', basketFurniture: cart })
        toast.success(`Dodano ${item.name} do wyceny!`)
    }

    const addMany = (items: CartItem[]) => {
        const cart = localStorage.get('cart') || [];

        items.forEach((item: CartItem) => {
            if (!cart.find((i: CartItem) => i.id === item.id)) {
                cart.push(item);
            }
        });

        localStorage.set('cart', cart);
        dispatch({ type: 'setCart', basketFurniture: cart })
        toast.success(`Dodano ${items.length} produktów do wyceny!`)
    }

    const remove = (id: string) => {
        const cart = localStorage.get('cart') || [];

        const itemIndex = cart.findIndex((cartItem: CartItem) => cartItem.id === id);

        if (itemIndex !== -1) {
            cart.splice(itemIndex, 1);
            localStorage.set('cart', cart);
            dispatch({ type: 'setCart', basketFurniture: cart })
        }
    }

    const clearCart = () => {
        localStorage.set('cart', []);
        dispatch({ type: 'setCart', basketFurniture: [] })
    }

    return {
        get,
        isInCart,
        add,
        addMany,
        remove,
        clearCart,
    }
}